<template>
  <div class="comparison-svg">
    <svg :width="svgSize" :height="svgSize" :fill="size === 'big' || size === 'normal' ? '#e7e7e7' : '#47474B'">
      <use :xlink:href="spritePath + '#comparison'"></use>
    </svg>
  </div>
</template>

<script>
import { spritePath } from '@/mixins/spritePath'

export default {
  name: 'ComparisonSvg',
  mixins: [spritePath],
  props: {
    size: String
  },
  computed: {
    svgSize () {
      if (this.size === 'normal') return 100
      return this.size === 'big' ? 140 : 25
    }
  }
}
</script>

<style lang="sass" scoped>
.comparison-svg
  display: flex

.comparison-svg--mobile-header svg
  width: 24px
  height: 24px

.comparison-modal__empty svg
  width: 100px
  height: 100px
  fill: #E7E7E7!important
</style>
